module.exports = "/next-static/_next/static/images/hero_image_small-96dc255d466d30f24cec321ce121178e.png";